var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-white"},[_c('div',{staticClass:"mx-auto max-w-4xl px-3 flex text-gray-600 leading-none align-middle p-2"},[_c('div',{staticClass:"w-9/12 overflow-hidden flex align-middle justify-end text-right items-center"},[_c('span',{staticClass:"font-bold text-sm ml-3"},[_vm._v("PAGAMENTO 100% SEGURO")])])])])
}]

export { render, staticRenderFns }